import { render, staticRenderFns } from "./ResourceFee.vue?vue&type=template&id=605fd914&"
import script from "./ResourceFee.vue?vue&type=script&lang=js&"
export * from "./ResourceFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports